import { render, staticRenderFns } from "./BulkAddTagsModal.vue?vue&type=template&id=612b37cf&scoped=true"
import script from "./BulkAddTagsModal.vue?vue&type=script&lang=js"
export * from "./BulkAddTagsModal.vue?vue&type=script&lang=js"
import style0 from "./BulkAddTagsModal.vue?vue&type=style&index=0&id=612b37cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612b37cf",
  null
  
)

export default component.exports